export const SET_DATA = 'DATA';
export const DATA_LOADING='DATA_LOADING';
export const SET_CONTACT_US_FINISH = 'SET_CONTACT_US_FINISH';
export const SET_TRANSLATION='SET_TRANSLATION';
